export default "__VITE_ASSET__BMCYqJAS__"